import React from 'react';
import classNames from 'classnames';
import { Check } from '../../lib/svg-images';
import './SuccessLabel.less';

export default function SuccessLabel({ text, variant = 'platinum', className }) {
  return (
    <div className={classNames('SuccessLabel', `SuccessLabel_${variant}`, className)}>
      <Check />
      {text}
    </div>
  );
}

SuccessLabel.propTypes = {};
